<!--==================================================
    component name  : 頁尾資訊
    author          : Samma
    last update     : 2020-05-05
    use description : 
==================================================-->
<template>
  <footer>
    <div class="footerlinebox">
      <div class="footerline"></div>
    </div>
    <div class="container">
      <a href="https://line.me/R/ti/p/%40dqt5211c" target="_blank">
        <i class="fab fa-line"></i>
      </a>
      <a
        href="https://www.facebook.com/OWLocker-%E6%99%BA%E6%85%A7%E5%9E%8B%E5%AF%84%E7%89%A9%E6%AB%83-333809637076627/"
        target="_blank"
      >
        <i class="fab fa-facebook-square"></i>
      </a>
      <a
        href="https://www.youtube.com/channel/UCP8aPq40HDRUFhL1dLWxAiQ"
        target="_blank"
      >
        <i class="fab fa-youtube"></i>
      </a>
      <a href="https://twitter.com/OWLockers" target="_blank">
        <i class="fab fa-twitter"></i>
      </a>
    </div>

    <div class="container">
      <div class="box">
        <div class="box1">
          <p>
            Copyright © 2020
            <a href="https://www.gamezone99.com">{{
              $t('message.ft_company')
            }}</a>
          </p>
        </div>
        <div class="box2">
          <p>&nbsp;{{ $t('message.ft_rights') }}</p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'GzFooter',
};
</script>
